export default (tel, email) => ({
	tel: tel,
	tel_display: null,
	email: email,
	email_display: null,
	open: false,
	form: null,
	init() {
        this.form = this.$root.querySelector('form');
		this.tel_display = this.$root.querySelector(".telephone");
		if (this.tel_display) {
			this.tel_display.innerText = this.tel;
		}
		this.email_display = this.$root.querySelector(".email");
		if (this.email_display) {
			this.email_display.innerText = this.email;
		}
	},
	closeModal() {
        this.open = false;
        this.form.reset();
    },
});
